import Link from 'next/link';

import type { Story } from '@/src/types';
import { Avatar } from '@/src/ui/Avatar/Avatar';

import styles from './AuthorCard.module.scss';

interface Props {
    author: NonNullable<Story['authors']>[number];
}

export function AuthorCard({ author }: Props) {
    const authorContent = (
        <>
            <Avatar name={author.name} image={author.photos?.[0]?.photo} size="xl" />
            <div className={styles.info}>
                <strong className={styles.name}>{author.name}</strong>
                {author.role && <span className={styles.role}>{author.role}</span>}
            </div>
        </>
    );

    if (author.hasAuthorPage && author.slug) {
        return (
            <Link className={styles.card} href={`/authors/${author.slug}`}>
                {authorContent}
            </Link>
        );
    }

    return <div className={styles.card}>{authorContent}</div>;
}
